import { formatEther } from "viem";

import type { ActivityEvent } from "@stonkland/protocol/api-types";

const ASSET_COLORS = ["#d5ff3f", "#8fa7ff", "#ffb86b", "#75e6da", "#ff776b"];

export const compactAddress = (value: string) =>
  `${value.slice(0, 6)}…${value.slice(-4)}`;

export const amountLabel = (value: bigint | undefined, digits = 4) => {
  if (value === undefined) return "—";
  return Number(formatEther(value)).toLocaleString("en-US", {
    maximumFractionDigits: digits,
  });
};

export const decimalLabel = (value: string, digits = 6) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return value;
  return parsed.toLocaleString("en-US", {
    maximumFractionDigits: digits,
  });
};

export const assetColor = (address: string) => {
  const index = Number.parseInt(address.slice(-2), 16) % ASSET_COLORS.length;
  return ASSET_COLORS[index];
};

export const eventLabel = (event: ActivityEvent) => {
  const labels: Record<string, string> = {
    BrokerMinted: "BROKER MINTED",
    NFTBought: "BROKER BOUGHT",
    NFTSold: "BROKER SOLD",
    Activated: "SENT TO WORK",
    ActivationUpgraded: "WORK UPGRADED",
    ActivationCleared: "WORK CLEARED",
    DropStarted: "STOCK DROP STARTED",
    DropPaid: "STOCKS PUSHED TO BROKER",
    DropFinished: "STOCK DROP FINISHED",
    LoanCreated: "BROKER LOAN OPENED",
    LoanRepaid: "BROKER LOAN REPAID",
    LoanLiquidated: "BROKER LOAN LIQUIDATED",
    EscrowReleased: "ESCROW TOKENS RELEASED",
    EscrowReturned: "ESCROW TOKENS RETURNED",
    Listed: "BROKER LISTED",
    Purchased: "BUNDLE PURCHASED",
    Transfer: "BROKER TRANSFERRED",
  };
  return labels[event.eventName] || event.eventName.replaceAll("_", " ");
};

export const eventTime = (timestamp: number) =>
  timestamp
    ? new Intl.DateTimeFormat("en", {
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      }).format(new Date(timestamp * 1000))
    : "TIMESTAMP UNAVAILABLE";
